/**********************************
 * Cookie functions
 ***********************************/

// Sets a cookie with the given name and value for the current session
function setSessionCookie(name, value) {
    if (!name || value === null || value === undefined) {
        console.warn('Invalid cookie parameters:', name, value);
        return;
    }
    
    try {
        // Encode value to handle special characters
        const encodedValue = encodeURIComponent(value);
        document.cookie = `${name}=${encodedValue}; path=/; SameSite=Lax`;
    } catch (error) {
        console.error('Error setting cookie:', error);
    }
}

// Gets a cookie with the given name
function getSessionCookie(name) {
    if (!name) {
        console.warn('Cookie name is required');
        return null;
    }
    
    try {
        const nameKey = name + "=";
        const cookies = document.cookie.split(';');
        
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameKey) === 0) {
                return decodeURIComponent(cookie.substring(nameKey.length));
            }
        }
        return null;
    } catch (error) {
        console.error('Error getting cookie:', error);
        return null;
    }
}

/**********************************
 * Legacy cookie functions (for compatibility)
 ***********************************/

function getCookie(name) {
    if (!name || !document.cookie.length) {
        return "";
    }
    
    try {
        const nameKey = name + "=";
        const cookies = document.cookie.split(';');
        
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameKey) === 0) {
                return decodeURIComponent(cookie.substring(nameKey.length));
            }
        }
        return "";
    } catch (error) {
        console.error('Error getting legacy cookie:', error);
        return "";
    }
}

function setCookie(name, value, days) {
    if (!name) {
        console.warn('Cookie name is required');
        return;
    }
    
    try {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        
        const encodedValue = encodeURIComponent(value || "");
        document.cookie = `${name}=${encodedValue}${expires}; path=/; SameSite=Lax`;
    } catch (error) {
        console.error('Error setting legacy cookie:', error);
    }
}

/**********************************
 * IP-based geolocation functionality
 ***********************************/

const GeoLocation = {
    ACCESS_KEY: '9da7c901697562382ec847a53ec9dd4e',
    COOKIE_NAME: 'zipcode',
    COOKIE_EXPIRY_DAYS: 5,
    
    // Check if we already have a stored zipcode
    hasStoredZipcode() {
        const zipcode = getCookie(this.COOKIE_NAME);
        return zipcode && zipcode.trim() !== '';
    },
    
    // Fetch zipcode from IP geolocation service
    async fetchZipcodeFromIP() {
        const url = `https://api.ipstack.com/check?access_key=${this.ACCESS_KEY}`;
        
        return new Promise((resolve, reject) => {
            // Use JSONP for cross-origin request
            $.ajax({
                url: url,
                dataType: 'jsonp',
                timeout: 10000, // 10 second timeout
                success: function(data) {
                    console.log('Geolocation response:', data);
                    
                    if (data && data.zip && /^\d{5}(-\d{4})?$/.test(data.zip)) {
                        resolve(data.zip);
                    } else {
                        console.warn('Invalid or missing zipcode in response:', data);
                        resolve(null);
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Geolocation API error:', status, error);
                    reject(new Error(`API request failed: ${status}`));
                }
            });
        });
    },
    
    // Initialize geolocation and trigger shipping lookup
    async init() {
        try {
            // Skip if we already have FastShip data
            if (getSessionCookie("FastShip.ZipCode") && getSessionCookie("FastShip.ReceiveByDateTime")) {
                console.log('FastShip data already stored, skipping geolocation');
                return;
            }
            
            let zipcode = getCookie(this.COOKIE_NAME);
            
            // If no stored zipcode, fetch from IP
            if (!zipcode || zipcode.trim() === '') {
                console.log('Fetching zipcode from IP geolocation...');
                zipcode = await this.fetchZipcodeFromIP();
                
                if (zipcode) {
                    setCookie(this.COOKIE_NAME, zipcode, this.COOKIE_EXPIRY_DAYS);
                    console.log('Zipcode saved from geolocation:', zipcode);
                } else {
                    console.log('No valid zipcode received from geolocation service');
                    return;
                }
            }
            
            // Now trigger the shipping calculation directly (without form submission)
            if (zipcode) {
                this.calculateShipping(zipcode);
            }
            
        } catch (error) {
            console.error('Geolocation initialization failed:', error);
        }
    },
    
    // Calculate shipping directly without form submission
    calculateShipping(zipcode) {
        console.log('Calculating shipping for zipcode:', zipcode);
        
        // Determine which API endpoint to use based on the site
        let url = 'https://shop.worldpantry.com/fastshipping/waldenfarms/zipcodelookup.aspx';
        let key = 'wp_2024_waldenfarms';
        
        // Check if we're on waldenfarms site (you can adjust this detection logic)
        if (window.location.hostname.includes('celestial')) {
            url = 'https://shop.worldpantry.com/fastshipping/waldenfarms/zipcodelookup.aspx';
            key = 'wp_2024_waldenfarms';
        }
        
        $.get(url, { zipcode: zipcode, key: key })
            .done(function(data) {
                console.log('Shipping calculation response:', data);
                
                if (data && data.Zip && data.ReceiveByDateTime) {
                    // Format dates
                    function formatDate(timestamp) {
                        if (!timestamp) return null;
                        var date = new Date(timestamp);
                        return date.toLocaleString('default', { month: 'long' }) + " " + date.getDate();
                    }
                    
                    var utc = new Date(data.OrderByDateTime);
                    var local = utc.toLocaleTimeString([], {hour: 'numeric'}).replace(' ','');
                    
                    var monthlyDate = new Date(data.ReceiveByDateTime);
                    var monthDate = monthlyDate.toLocaleString('default', {month: 'long', day: 'numeric'});
                    
                    // Store in cookies
                    if (data.Zip) {
                        setSessionCookie("FastShip.ZipCode", data.Zip);
                        setSessionCookie("zipcode", data.Zip);
                    }
                    
                    if (data.OrderByDateTime) {
                        setSessionCookie("FastShip.OrderByDateTime", formatDate(data.OrderByDateTime));
                        setSessionCookie("FastShip.OrderByHour", local);
                    }
                    
                    if (data.ReceiveByDateTime) {
                        setSessionCookie("FastShip.ReceiveByDateTime", formatDate(data.ReceiveByDateTime));
                        setSessionCookie("FastShip.OrderByMonth", monthDate);
                    }
                    
                    if (!data.FastShipCalculationError) {
                        console.log('Shipping data stored successfully, reloading to update display...');
                        // Reload the page to update the display with the new data
                        window.location.reload();
                    }
                }
            })
            .fail(function(xhr, status, error) {
                console.error('Shipping calculation failed:', status, error);
            });
    }
};

/**********************************
 * Auto-populate shipping form (when modal is opened)
 ***********************************/

const ShippingForm = {
    FORM_SELECTORS: '#enterzipcode, #mobilezipcode',
    
    // Auto-fill the form when modal is opened
    autoFill() {
        const zipcode = getCookie('zipcode');
        
        if (!zipcode || zipcode.trim() === '') {
            console.log('No zipcode available for auto-fill');
            return;
        }
        
        // Find visible input field
        const zipInput = $(this.FORM_SELECTORS).filter(':visible').first();
        
        if (zipInput.length > 0 && zipInput.val() === '') {
            console.log('Auto-filling zipcode in modal:', zipcode);
            zipInput.val(zipcode);
            
            // Trigger input event to enable submit button
            zipInput.trigger('input');
        }
    },
    
    // Initialize - bind to modal open events
    init() {
        // When modal is shown, auto-fill the zipcode
        $(document).on('click', '.shipping-arrival-modal-trigger', () => {
            setTimeout(() => {
                this.autoFill();
            }, 100);
        });
    }
};

/**********************************
 * Initialization
 ***********************************/

$(document).ready(function() {
    console.log('Initializing fast shipping geolocation...');
    
    // Initialize geolocation (this will also trigger shipping calculation)
    GeoLocation.init();
    
    // Initialize auto-fill for modal
    ShippingForm.init();
});

// Fallback initialization for cases where jQuery might load later
if (typeof $ === 'undefined') {
    document.addEventListener('DOMContentLoaded', function() {
        // Wait a bit more for jQuery to potentially load
        setTimeout(function() {
            if (typeof $ !== 'undefined') {
                console.log('jQuery loaded, initializing fast shipping...');
                GeoLocation.init();
                ShippingForm.init();
            } else {
                console.warn('jQuery not available, some features may not work');
            }
        }, 1000);
    });
}